import { z } from 'zod'

// Validation des mutations du questionnaire post-signature (règle projet : toute mutation REST
// passe par un schéma Zod). Le serveur revalide de toute façon les codes contre la définition
// figée du module : ce schéma sert à ne pas partir avec un payload manifestement incomplet.

export const programFeedbackModuleSchema = z.enum(['sound', 'insight', 'store_bag'])

/** Corps de `POST program_feedbacks/presentations` : la modale vient d'être affichée. */
export const programFeedbackPresentationSchema = z.object({
  module: programFeedbackModuleSchema,
  programId: z.number().int().positive(),
})

/**
 * Corps de `POST program_feedbacks/answers`. Cinq questions, chacune avec au moins une
 * modalité et au plus deux (le maximum réel par question est appliqué côté serveur).
 */
export const programFeedbackAnswersSchema = z.object({
  module: programFeedbackModuleSchema,
  programId: z.number().int().positive(),
  answers: z.record(z.string().min(1), z.array(z.string().min(1)).min(1).max(2)),
})

export type ProgramFeedbackPresentationPayload = z.infer<typeof programFeedbackPresentationSchema>
export type ProgramFeedbackAnswersPayload = z.infer<typeof programFeedbackAnswersSchema>
